
export type SystemProcessLoadingStatus = ('none' | 'loading' | 'updating' | 'done' | 'error' | 'deleting' | 'creating') | string;

export class SystemTypedError {
  processType: SystemProcessLoadingStatus;
  error: any
}

export class SystemProcess {
  constructor(status: SystemProcessLoadingStatus = 'none', error: string = '') {
    Object.assign(this, { status, error });
  }
  status: SystemProcessLoadingStatus;
  error?: {error, processType};
  errorBody?: any;
}


export class TimestampBased {
  createdAt?: number;
  updatedAt?: number;
}